export default "__VITE_ASSET__B6Na7YjG__"